import React from "react";
import { Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { actions as offlineAppActions } from "App/OfflineApp/offlineAppRedux.js";
import { appTypeSelector } from "App/OfflineApp/offlineAppSelectors";
import { useTranslate } from "lib/MrTranslate/MrTranslate";
import { actions as fireStoreReduxActions } from "views/Experiences/ExperienceShow/FirestoreInteractions/redux";

const BackToHomeBtn = (props) => {
  const dispatch = useDispatch();
  const appType = useSelector(appTypeSelector());
  const { experience } = props;
  const mrIntl = useTranslate()

  const shouldDispatchChangeSecurity =
    (appType === "mac" || appType === "ios") &&
    experience.settings.mode == "offline";

  const handleBackButtonClick = (e) => {
    dispatch(
      fireStoreReduxActions.setUserInfo(
        {},
        {
          log: {
            logging: true,
            action: props.action
          },
        }
      )
    );
    shouldDispatchChangeSecurity &&
      dispatch(
        offlineAppActions.executeMethod({ key: "changeSecurity", value: false })
      );
    return true;
  };

  const backToHomeBtn = (
    <Button
      key="back-to-home-btn"
      href="/"
      onClick={(e) => {
        return handleBackButtonClick();
      }}
    >
     {mrIntl("CommonText.back_to_home")}
    </Button>
  );
  return backToHomeBtn;
};

export default BackToHomeBtn;
